"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
exports.default = _ref => {
  let width = _ref.width,
    height = _ref.height;
  return react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 52 33"
  }, react_1.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, react_1.default.createElement("path", {
    fill: "#222",
    fillRule: "nonzero",
    d: "M45.707 11.971c2.212 1.203 2.223 3.153.027 4.355l-15.732 8.61c-2.194 1.201-5.77 1.201-7.98 0l-15.835-8.61c-2.21-1.202-2.22-3.156-.026-4.355l15.732-8.61c2.194-1.203 5.77-1.203 7.98 0l2.812 1.52-2.284 1.25c-2.804 1.535-2.786 4.02.033 5.554 2.82 1.532 7.375 1.532 10.176 0l2.287-1.25 2.81 1.536z"
  }), react_1.default.createElement("path", {
    fill: "#222",
    fillRule: "nonzero",
    d: "M43.27 8.695c.779.434.787 1.112 0 1.537l-.382.217-2.278 1.244c-2.801 1.533-7.356 1.533-10.176 0-2.82-1.532-2.837-4.018-.033-5.553l2.295-1.25.384-.218a3.27 3.27 0 0 1 2.822 0l7.368 4.023zm-4.472 1.971l1.703-.933c.493-.27.491-.71 0-.98l-4.713-2.559a2.1 2.1 0 0 0-1.797 0l-1.7.931c-1.787.977-1.776 2.564.02 3.541 1.794.977 4.703.977 6.487 0z"
  }), react_1.default.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M37.043 16.426c.996.543.998 1.422.01 1.954l-6.889 3.773c-1.974 1.086-5.165 1.086-7.144 0-1.979-1.085-1.987-2.822-.022-3.907l6.892-3.752c.985-.54 2.596-.543 3.592 0l3.56 1.932z"
  }), react_1.default.createElement("path", {
    fill: "#222",
    fillRule: "nonzero",
    d: "M49.867 11.513c2.675 1.455 2.688 3.817.031 5.271l-19.04 10.421c-2.66 1.455-6.988 1.455-9.654 0L2.038 16.785c-2.692-1.444-2.692-3.817-.041-5.272L21.039 1.092c2.657-1.455 6.986-1.455 9.654 0l19.174 10.421zM30.002 24.937l15.732-8.61c2.194-1.203 2.194-3.153-.027-4.356l-2.81-1.52.381-.217c.78-.434.77-1.113 0-1.537l-7.387-4.014a3.27 3.27 0 0 0-2.822 0l-.384.217-2.812-1.52c-2.21-1.202-5.784-1.202-7.98 0L6.16 11.971c-2.194 1.203-2.194 3.153.026 4.355l15.835 8.61c2.21 1.201 5.784 1.201 7.98 0z"
  }), react_1.default.createElement("path", {
    fill: "#222",
    fillRule: "nonzero",
    d: "M40.496 8.754c.496.269.498.71 0 .979l-1.702.933c-1.784.977-4.691.977-6.488 0-1.797-.977-1.806-2.564-.02-3.54l1.7-.932a2.1 2.1 0 0 1 1.797 0l4.713 2.56zm-7.36 1.459c.647.309 1.401.309 2.048 0 .384-.217.496-.506.358-.775l1.775-.97c.272-.15.27-.394 0-.541a1.145 1.145 0 0 0-.99 0l-1.774.97a2.377 2.377 0 0 0-1.42.198c-.568.31-.562.81 0 1.118h.002z"
  }), react_1.default.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M25.364 10.078c.998.543 1 1.42.013 1.954l-6.892 3.78c-1.974 1.085-5.16 1.085-7.142 0-1.98-1.086-1.987-2.823-.024-3.908l6.896-3.763c.988-.538 2.596-.54 3.594 0l3.555 1.937z"
  }), react_1.default.createElement("path", {
    fill: "#222",
    d: "M25.545 8.136l3.093 3.95 6.193 2.216 7.266 4.865 7.155-5.13-3.134-3.554-1.81-1.567-10.56-5.562-6.112.49z"
  }), react_1.default.createElement("path", {
    fill: "#9BA8B2",
    fillRule: "nonzero",
    d: "M49.898 16.784l-19.04 10.421-.016 4.594 19.043-10.42c1.316-.724 1.975-1.67 1.975-2.619l.013-4.596c.006.96-.654 1.897-1.975 2.62z"
  }), react_1.default.createElement("path", {
    fill: "#DCE4EA",
    fillRule: "nonzero",
    d: "M21.195 27.208L2.03 16.787C.682 16.053.004 15.09.004 14.129v4.596c0 .962.67 1.924 2.015 2.656L21.184 31.8c2.677 1.457 7.006 1.457 9.654 0l.015-4.593c-2.655 1.454-6.983 1.454-9.658 0z"
  }), react_1.default.createElement("path", {
    fill: "#222",
    fillRule: "nonzero",
    d: "M32.282 7.974l-.459 1.157.459.967.912.584 1.922.369 1.74-.604 1.176-.936.163-.816-.878-.768-.134-.754h-2.909z"
  }), react_1.default.createElement("path", {
    fill: "#DA1F26",
    fillRule: "nonzero",
    d: "M30.063 6.222l-.923.94-.092-.666.482-.489.5-.034.033.25zm.047-.805l.48-.489.8-.054-.925.94-.303.024-.052-.421zM31.58 8.96l-1.736-1.188.8-.054.841.575.095.667zm.98-1.652l.046.332-.401.026-.95-.651-.046-.335.39-.024.961.652zm.092.705l-.921.938-.092-.666.48-.487.498-.032.035.247zm1.317-1.47l-.799.055-.844-.593-.09-.651 1.733 1.19zm-1.273.66l.483-.49.794-.05-.921.936-.303.024-.053-.42zM33.556 7.944l.924-.94.092.666-.482.489-.503.037-.03-.252zm1.402 1.003l.047.332-.402.028-.95-.651-.046-.332.4-.028.951.65zm.093.708l-.924.938-.092-.665.482-.49.5-.033.034.25zm.046-.806l.48-.488.799-.055-.922.938-.305.026-.052-.42zM34.513 10.973l.356-.36.438.305-.355.36zM37.225 12.833l-1.731-1.183.8-.054.839.577.092.66zm-.423-2.662l.925-.94.097.652-.485.49-.507.042-.03-.244zm1.404 1.003l.044.333-.4.028-.95-.652-.035-.334.4-.028.94.653zm.092.708l-.922.936-.09-.664.479-.489.498-.032.035.25zm1.316-1.472l-.798.054-.854-.575-.09-.666 1.742 1.187zm-1.266.667l.483-.49.794-.049-.921.936-.303.024-.053-.421z"
  })));
};